const HMADM = () => import('../views/Home.vue')
const OSITE = () => import('../views/OSite.vue')
const AdminPages = () => import('../views/AdminPages.vue')
const Paginas = () => import('../views/Paginas.vue')
const Pessoas = () => import('../views/Pessoas.vue')
const Dados = () => import('../views/UploadDados.vue')
const Users = () => import('../views/Usuarios')
const GrupoAdm = () => import('../views/GrupoMenuAdmin.vue')
const MenuAdm = () => import('../views/MenusAdmin.vue')
const MenuCat = () => import('../views/menuCategory.vue')
const PROGRAM = () => import('../views/Programs')
const ACESUSE = () => import('../views/AcessoUser')
const PGVIEWS = () => import('../views/pageViews')
const PGPerguntas = () => import('../views/PerguntasFrequentes.vue')
const PGUpload = () => import('../views/UploadsDiversos.vue')

export default [
  { name: 'viewAdministracao', path: '/administracao', component: HMADM, meta: { acl: true } },
  { name: 'viewOSsite', path: '/admin/cadastro-pagina-geral', component: OSITE, meta: { acl: false } },
  { name: 'viewDesh', path: '/admin/admin-pages', component: AdminPages, meta: { acl: true } },
  { name: 'viewPaginas', path: '/admin/paginas-do-site', component: Paginas, meta: { acl: true } },
  { name: 'viewPessoa', path: '/admin/cadastro/pessoas', component: Pessoas, meta: { acl: true } },
  { name: 'viewDados', path: '/admin/cadastro/upload-de-dados', component: Dados },
  { name: 'viewGrupos-menu', path: '/admin/cadastro/grupos-de-menus-admin', component: GrupoAdm, meta: { acl: true } },
  { name: 'viewMenu-sys', path: '/admin/cadastro/menus-do-sistema', component: MenuAdm, meta: { acl: true } },
  { name: 'viewMenu-cat', path: '/admin/cadastro/menus-por-categoria', component: MenuCat, meta: { acl: true } },
  { name: 'viewUsuarios', path: '/admin/cadastro/usuarios', component: Users, meta: { acl: true } },
  { name: 'viewPerguntas', path: '/admin/cadastro/perguntas-frequentes', component: PGPerguntas, meta: { acl: true } },
  { name: 'viewProgramas', path: '/admin/parametros/programs', component: PROGRAM, meta: { acl: true } },
  { name: 'viewAcessos', path: '/admin/parametros/acesso-por-usuario', component: ACESUSE, meta: { acl: true } },
  { name: 'viewViews', path: '/admin/views', component: PGVIEWS, meta: { acl: true } },
  { name: 'viewWpload', path: '/admin/uploads-diversos', component: PGUpload, meta: { acl: true } }
]
